module.exports = __webpack_public_path__ + "img/dropsLive_460.831415f9.png";